import React from 'react';
import { HeaderArea } from '../../organisms/HeaderArea';
import { MainArea } from '../../organisms/MainArea';
import './index.scss';

interface Props {
  headerItem1?: React.ReactNode;
  headerItem2?: React.ReactNode;
  mainItem1?: React.ReactNode;
  mainItem2?: React.ReactNode;
  mainItem3?: React.ReactNode;
  mainItem4?: React.ReactNode;
  mainItem5?: React.ReactNode;
  mainItem6?: React.ReactNode;
  mainItem7?: React.ReactNode;
  mainItem8?: React.ReactNode;
  mainItem9?: React.ReactNode;
  mainItem10?: React.ReactNode;
  mainItem11?: React.ReactNode;
  mainItem12?: React.ReactNode;
  mainItem13?: React.ReactNode;
  mainItem14?: React.ReactNode;
  portalTitle?: string;
  mode?: string;
}
export const ViewScreen = ({
  headerItem1,
  headerItem2,
  mainItem1,
  mainItem2,
  mainItem3,
  mainItem4,
  mainItem5,
  mainItem6,
  mainItem7,
  mainItem8,
  mainItem9,
  mainItem10,
  mainItem11,
  mainItem12,
  mainItem13,
  mainItem14,
  portalTitle,
  mode
}: Props) => {
  return (
    <div className="viewScreen_hero">
      <HeaderArea
        portalTitle={portalTitle}
        child1={headerItem1}
        child2={headerItem2}
      />
      <MainArea
        mode={mode}
        child1={mainItem1}
        child2={mainItem2}
        child3={mainItem3}
        child4={mainItem4}
        child5={mainItem5}
        child6={mainItem6}
        child7={mainItem7}
        child8={mainItem8}
        child9={mainItem9}
        child10={mainItem10}
        child11={mainItem11}
        child12={mainItem12}
        child13={mainItem13}
        child14={mainItem14}
      />
    </div>
  );
};
